const isFunction = (value) => (typeof value === "function");
export default isFunction;
